import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Router } from "@angular/router"
import { Observable, BehaviorSubject } from 'rxjs';
import 'firebase/firestore';
import { map } from 'rxjs/operators';
import { DatosModule } from '../modelos/datos/datos.model';
import { Datossopa } from '../modelos/datos/datossopa.model';
import { Datossecuencia } from '../modelos/datos/datossecuencia.model';
import { Datospregunta } from '../modelos/datos/datospregunta.model';
import { DatosCuestionario } from '../modelos/datos/datoscuestionario.model';
import { DatosUsuario } from '../modelos/datosusuario.model';
@Injectable({
  providedIn: 'root'
})
export class ServicioFirebaseService {

  public uid: string;
  private itemDoc: AngularFirestoreDocument<any>;
  public Datosactividadsopa: Observable<any>;
  constructor(public afAuth: AngularFireAuth, private db: AngularFirestore, private router: Router) { }

  registrarUsuarioCorreo(correo: string, contra: string, nombre: string, apellidoP: string, apellidoM: string, institucion: string, plan: string, tarjeta: string) {
    return this.afAuth.createUserWithEmailAndPassword(correo, contra).then(res => {
      this.registrarDatosPersonalesUsuario(res.user.uid, nombre, apellidoP, apellidoM, institucion, plan, tarjeta)
    }).catch(function (error) {
      return error;
    });

  }
  registrarDatosPersonalesUsuario(uid: string, nombre: string, apellidoP: string, apellidoM: string, institucion: string, plan: string, tarjeta: string) {
    this.db.collection("usuarios").add({
      uid: uid,
      nombre: nombre,
      apellidopaterno: apellidoP,
      apellidomaterno: apellidoM,
      institucion: institucion,
      plan: plan,
      tarjeta: tarjeta
    })
  }
  entrarSesionCorreo(correo: string, contra: string) {
    return this.afAuth.signInWithEmailAndPassword(correo, contra).then(res => {
      console.log('onSuccess');
      this.uid = res.user.uid;
      this.router.navigate(['menuusuario/misactividades']);
      alert("entraste");
      return true;
    })
      .catch(function onFailure(err) {
        //alert(err);
        console.log('onFailure', err);
        return false;
      });
  }
  cerrarSesion() {
    return this.afAuth.signOut().then(res => {
      alert("saliste");
      this.router.navigate(['/']);
      return true;
    })
      .catch(function onFailure(err) {
        console.log('onFailure', err);
        return false;
      });
  }
  tomarInformacionUsuario(uid: string){
    return this.db.collection('usuarios', ref => ref.where('uid', '==', uid)).snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as {
          uid: string
          titulo: string
          tipo: string
          descripcion: string
        };
        const id = a.payload.doc.id;
        //alert(id);
        return { id, ...data };
      }))
    );
  }
  modificarInformacionUsuario(info:DatosUsuario,uid: string){
    this.itemDoc= this.db.doc<DatosUsuario>(`usuarios/${uid}`);
    return this.itemDoc.update(info);
  }
  asignarActividades(uid: string): Observable<any> {
    return this.db.collection('actividades-creadas', ref => ref.where('uid', '==', uid)).snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as {
          uid: string
          titulo: string
          tipo: string
          descripcion: string
        };
        const id = a.payload.doc.id;
        //alert(id);
        return { id, ...data };
      }))
    );
  }
  eliminarTarea(act) {
    this.itemDoc = this.db.doc<any>(`actividades-creadas/${act.id}`);
    return this.itemDoc.delete();
  }
  eliminarActividadRealizada(act) {
    this.itemDoc = this.db.doc<any>(`actividades-realizadas/${act.id}`);
    return this.itemDoc.delete();
  }
  darDatosActividadesRealizadas(uid: string) {
    return this.db.collection<DatosModule>('actividades-realizadas', ref => ref.where('uid', '==', uid)).snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as {
          calificacion:string
          nombre :string
          tiempo:string
          tipo :string
          titulo:string
          uid:string
        };
        const id = a.payload.doc.id;
        //alert(id);
        return { id, ...data };
      }))
    );
  }

  crearNuevaActividadSopa(uid: string,tipo:string, titulo: string, des: string, op: string, difi: string, res: Array<number>, celdas: Array<number>) {
    return this.db.collection('actividades-creadas').add({
      uid: uid,
      tipo:tipo,
      titulo: titulo,
      descripcion: des,
      operacion: op,
      dificultad: difi,
      resultados: res,
      celdas: celdas,
    });
  }
  crearNuevaActividadSecuencia(uid: string,tipo:string, titulo: string, des: string, dessecuencia: string, pasos: Array<number>) {
    return this.db.collection('actividades-creadas').add({
      uid: uid,
      tipo:tipo,
      titulo: titulo,
      descripcion: des,
      descripcionsecuencia: dessecuencia,
      pasos:pasos,
    });
  }
  crearNuevaActividadCuestionario(uid: string,tipo:string, titulo: string,des: string,preguntas: Array<Datospregunta>) {
    return this.db.collection('actividades-creadas').add({
      uid: uid,
      tipo:tipo,
      titulo: titulo,
      descripcion: des,
      preguntas:preguntas,
    });
  }
  ///////////////////
  accederActividad(id: string) {
    const datosactividad = this.db.collection<Datossopa>('actividades-creadas').doc(id)
    return new Promise(resolve => {
      this.db.collection('actividades-creadas').doc(id).get().subscribe((docSnapshot) => {
        if (docSnapshot.exists) {
          switch(docSnapshot.data().tipo){
            case "sopa":
            this.router.navigate(['/actividadsopa/'+id]);
            break;
            case "secuencia":
            this.router.navigate(['/actividadsecuencia/'+id]);
            break;
            case "cuestionario":
            this.router.navigate(['/actividadcuestionario/'+id]);
            break;
          }
        } else {
          resolve("no existe");   
        }
      });
    });
  }
  tomarInformacionActividad(clave:string){
    return this.db.collection("actividades-creadas").doc<Datossopa>(clave).valueChanges();
  }
  tomarInformacionActividadSecuencia(clave:string){
    return this.db.collection("actividades-creadas").doc<Datossecuencia>(clave).valueChanges();
  }
  tomarInformacionActividadCuestionario(clave:string){
    return this.db.collection("actividades-creadas").doc<DatosCuestionario>(clave).valueChanges();
  }
  registrarActividadHecha(calificacion:string,nombre:string,tiempo:string,tipo:string,titulo:string,uid:string){
    this.db.collection("actividades-realizadas").add({
      calificacion:calificacion,
      nombre:nombre,
      tiempo:tiempo,
      tipo:tipo,
      titulo:titulo,
      uid:uid
    });

  }
  poner(uid: string) {
    this.db.collection('actividades-creadas').add({
      uid: uid,
      titulo: "Algoritmos de cocina",
      tipo: "secuencia",
      descripcion: "Ejercicio de secuencia de hacer la tarea"
    });
  }



}